<template>
  <v-container fluid grey lighten-3 pa-10>
    <v-row class="justify-center">
      <v-col>
        <v-card class="mx-auto" max-width="450">
          <v-card-title>เพิ่ม สาขา</v-card-title>
          <v-card-text>
            <v-form v-model="valid" ref="form" @submit.prevent="submit">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="item.name"
                      :rules="nameRules"
                      :counter="50"
                      label="ชื่อ สาขา"
                      id="name"
                      maxlength="50"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="item.tag"
                      :counter="3"
                      :rules="[
                        () =>
                          (!!item.tag && item.tag.length == 3) ||
                          'กรุณากรอกให้ถูกต้อง'
                      ]"
                      maxlength="3"
                      label="tag"
                      id="tag"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                      v-model="item.detail"
                      label="รายละเอียด"
                      id="detail"
                    ></v-textarea>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="item.no"
                      type="number"
                      label="No ลำดับ"
                      id="no"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-file-input
                      label="File input"
                      accept="image/*"
                      prepend-icon="mdi-camera"
                      type="file"
                      @change="onFileSelected"
                    ></v-file-input>
                    <div v-if="imageUrl">
                      <v-img
                        v-if="imageUrl"
                        :src="imageUrl"
                        max-height="150"
                        max-width="150"
                        class="mt-2"
                      ></v-img>
                    </div>
                  </v-col>

                  <v-col cols="12">
                    <v-switch
                      v-model="item.active"
                      label="Active"
                      color="success"
                      hide-details
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-divider class="mt-5 mb-5"></v-divider>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-btn color="gray" class="mr-5" @click="reset">ยกเลิก</v-btn>
                  <v-btn :disabled="!valid" color="success" type="submit">
                    <v-icon dark class="mr-1"
                      >mdi-checkbox-marked-circle</v-icon
                    >
                    บันทึก</v-btn
                  >
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import api from "@/services/api"

export default {
  name: "BranchCreate",
  data() {
    return {
      item: {
        name: "",
        tag: "",
        image: "",
        detail: "",
        no: 0,
        active: 0
      },
      nameRules: [
        v => !!v || "Name is required",
        v =>
          (typeof v != "undefined" && v.length <= 50) ||
          "Name must be less than 50 characters"
      ],
      imageUrl: null,
      valid: true
    }
  },
  methods: {
    async submit() {
      //alert(JSON.stringify(this.item))

      if (this.$refs.form.validate()) {
        let formData = new FormData()
        formData.append("name", this.item.name)
        formData.append("tag", this.item.tag)
        formData.append("detail", this.item.detail)
        formData.append("no", this.item.no)
        formData.append("active", this.item.active ? 1 : 0)
        formData.append("image", this.item.image)
        await api.addBranch(formData)
        this.$router.push("/branch")
      }
    },
    onFileSelected(event) {
      const reader = new FileReader()
      if (typeof event == "undefined") {
        this.imageUrl = ""
      }

      reader.onload = event => {
        this.imageUrl = event.target.result
      }

      if (event) {
        reader.readAsDataURL(event)
      }
      this.item.image = event
    },
    cancel() {
      this.$router.push("/Branch")
    },
    reset() {
      this.imageUrl = ""
      this.item.image = ""
      this.$refs.form.reset()
    }
  }
}
</script>

<style></style>
